import { Link } from "react-router-dom";
import { articles, flashes } from "@/mocks/news";

/* 侧栏：热搜热读榜 + 即时快讯 */
export default function TrendingPanel() {
  const topList = [...articles].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <aside className="space-y-6" aria-label="侧边栏">
      {/* 热搜热读榜 */}
      <section className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
        <div className="px-5 py-4 border-b border-background-100 flex items-center justify-between">
          <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500 inline-block"></span>
            热搜热读榜
          </h3>
          <i className="ri-fire-line text-primary-600"></i>
        </div>
        <ol className="divide-y divide-background-100/70">
          {topList.map((a, idx) => (
            <li key={a.id}>
              <Link to={`/news/${a.id}`} className="group flex items-center gap-3 px-5 py-3.5 hover:bg-background-100/60 transition-colors">
                <span
                  className={`w-6 h-6 flex items-center justify-center rounded text-xs font-bold flex-shrink-0 ${
                    idx < 3 ? "bg-primary-600 text-background-50" : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {idx + 1}
                </span>
                <span className="flex-1 text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </span>
                <i className="ri-eye-line text-xs text-foreground-400 flex-shrink-0"></i>
              </Link>
            </li>
          ))}
        </ol>
        <div className="px-5 py-3">
          <Link
            to="/about#contact"
            className="block text-center text-sm text-primary-700 hover:text-primary-600 font-medium"
          >
            参与更多讨论 →
          </Link>
        </div>
      </section>

      {/* 即时快讯 */}
      <section className="bg-background-100 border border-background-200 rounded-lg p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
            <span className="relative flex w-2.5 h-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-600"></span>
            </span>
            即时快讯
          </h3>
          <Link to="/" className="text-xs text-foreground-500 hover:text-primary-700">
            更多
          </Link>
        </div>
        <ul className="space-y-3.5">
          {flashes.slice(0, 4).map((f, i) => (
            <li key={i} className="flex gap-3 text-sm">
              <span className="text-primary-700 font-mono text-xs pt-0.5 whitespace-nowrap">{f.time}</span>
              <span className="text-foreground-700 leading-relaxed">
                <em className="not-italic font-medium text-foreground-800">{f.tag} · </em>
                {f.text}
              </span>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}